<div class="main-container">
    <div class="heading">Registeration Type</div>
    <div class="button-container">
        <button (click)="redirectToNB()">New Building</button>
        <button (click)="redirectToEB()">Existing Builduing</button>
        <button (click)="redirectToEDS()">Existing Day Schools</button>
        <button (click)="redirectToGFC()">GRIHA for Cities</button>
    </div>
</div>
